import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../../store"
import OldUIContext from "../../../olduicontext"

import LoginPage from "./components/LoginPage"
import { IOldUIContext } from "../../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): void {
    const element = document.getElementById("newui-login")

    if (!element) {
        return // we're not on the login page, no need to init the login sub app
    }

    const root = createRoot(element)
    root.render(
        <Provider store={store}>
            <OldUIContext.Provider value={oldUIContext}>
                <LoginPage />
            </OldUIContext.Provider>
        </Provider>,
    )
}

export default init
